'use strict';

export class FaqContact {
	constructor(component_id) {
		this.id = component_id;
	}

	init() {
		const $root = jQuery('.js-' + this.id);
		this.$organism = $root.closest('.organism--faq');

		jQuery(document).on('click', '[href*="&form"]', (e) => {
			this.show();
		});

		jQuery(document).on('click', '.js-faq_header_box__icon', () => this.hide());

		jQuery(document).on('submit', '.js-faq_contact_form', () => {
			yalwa.basics.ga.ping_metric('CM_CONTACT_SUPPORT', 1);
		});

		jQuery(document).on('invalid', '.js-faq_contact_form input', function() {
			if (!yalwa.v.is_dol) {
				jQuery(this).attr('placeholder', this.validationMessage);
			}
			jQuery('.js-main_col').scrollTop(0);
		});

		if (window.location.pathname.indexOf('faq_contact') !== -1 || window.location.search.search('form') !== -1) {
			jQuery('.js-faq_header_box__icon').hide();
			this.show();
		}
	}

	show() {
		const $org = this.$organism || jQuery('.organism--faq');
		const new_hash = window.location.hash;
		jQuery('.js-contact_form_c').val(new_hash.substr(1));

		jQuery('.js-faq_contact_form').attr('action', new_hash +
			(new_hash.indexOf('&form') === -1 ? (new_hash ? '&form' : '?form') : ''));

		$org.find('.js-faq_categories_faq_categories, .js-accordion_popular').slideUp();
		$org.find('.js-faq_search_top').slideUp();
		jQuery('.js-contact_form_wrapper').removeClass('hidden').slideDown();
		jQuery('.main_col').animate({ scrollTop: 0 }, 500);
	}

	hide() {
		const $org = this.$organism || jQuery('.organism--faq');
		$org.find('.js-faq_categories_faq_categories, .js-accordion_popular').slideDown();
		$org.find('.js-faq_search_top').slideDown();
		jQuery('.js-contact_form_wrapper, .js-faq_contact_error__wrapper').slideUp(function() {
			jQuery(this).addClass('hidden');
		});
	}
}

const init_faq_contact = () => {
	if (typeof yalwa === 'undefined' || !yalwa.v || !yalwa.v.components) return;
	for (const key in yalwa.v.components) {
		if (key.startsWith('faq_contact_')) {
			new FaqContact(key).init();
		}
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init_faq_contact);
} else {
	init_faq_contact();
}